let currentStep = 1;
const totalSteps = 5;
let travellers = []; 
let currentEditingIndex = -1;  // -1 means new traveller, >= 0 means editing existing
const additionalDays = 1;      

window.restoreCompleted = false;

// API Configuration
const API_CONFIG = {
  API_KEY: "caab6668-d9aa-4bd0-9c05-785e5341d39c", // Add your API key here
  SECRET: "79a02f58527945d8b8ee742dd9305ee3", // Add your secret key here
  API_URL: "https://azcms.matrix.co.in", // Add your API URL here
  API_ENDPOINT: "/shopify/visa/fetchPassportDetails",
  SAVE_TRAVELLER_ENDPOINT: "/shopify/visa/saveTravellerDetails",
  GET_TRAVELLER_LIST: "/shopify/visa/fetchTravellerDetails",
  EDIT_TRAVELLER:"/shopify/visa/editTravellerDetail",
  DELETE_TRAVELLER:"/shopify/visa/removeTravellerDetail",
  SEND_OTP: "/shopify/visa/sendOtp",
  VERIFY_OTP: "/shopify/visa/verifyOtp"
};



// document.addEventListener("DOMContentLoaded", function() {
//     initTravellers();
// });


// function initTravellers() {
//     console.debug("[Progress] initTravellers()");
//     try {
//         const savedJSON = localStorage.getItem("uaeVisaProgress");
//         if (!savedJSON) {
//             console.debug("[Progress] no saved JSON found");
//             window.travellers = window.travellers || [];
//             return;
//         }

//         const loaded = loadProgress();
//         if (!loaded) {
//             console.debug("[Progress] persisted data invalid");
//             return;
//         }

//         console.debug("[Progress] will restore:", loaded);
//         restoreProgress(loaded);

//         if (typeof showProgressPrompt === "function") {
//             showProgressPrompt(loaded);
//         }

//     } catch (err) {
//         console.warn("[Progress] initTravellers failed:", err);
//         window.travellers = window.travellers || [];
//     }
// }


// Store uploaded files
let uploadedFiles = {
  passportFront: null,
  passportBack: null,
  travellerImage: null,
};

// Store selected data
let selectedData = {
  "visitType": "Tourist"
}

// store signup form action
const signupForm = document.getElementById("signupForm");
let shopifyOriginalOnSubmit = signupForm.onsubmit;

// prevent default sign up to call OTP Api
signupForm.onsubmit = function (e) {
    e.preventDefault(); 
};

// Progress saving and restoration functionality
function saveProgress() {
  
  const newData = {
    currentStep: currentStep,
    travellers: JSON.parse(JSON.stringify(window.travellers || [])),
    isUserLoggedIn: Boolean(userLoggedIn),

    formData: {
      // Step 1 data
      title: document.getElementById("title")?.value || "",
      firstName: document.getElementById("firstName")?.value || "",
      middleName: document.getElementById("middleName")?.value || "",
      lastName: document.getElementById("lastName")?.value || "",
      gender: document.getElementById("gender")?.value || "",
      dob: document.getElementById("dob")?.value || "",
      occupation: document.getElementById("occupation")?.value || "",
      mobile: document.getElementById("mobile")?.value || "",
      email: document.getElementById("email")?.value || "",
      passportNumber: document.getElementById("passportNumber")?.value || "",
      passportExpiry: document.getElementById("passportExpiry")?.value || "",
      travelStartDate: document.getElementById("travelStartDate")?.value || "",
      travelEndDate: document.getElementById("travelEndDate")?.value || "",
    },

    uploadStates: {
      travelerPhotoUploaded: document.getElementById("travelerPhotoUpload")?.classList.contains("uploaded") || false,
      passportFrontUploaded: document.getElementById("passportFrontUpload")?.classList.contains("uploaded") || false,
      passportBackUploaded: document.getElementById("passportBackUpload")?.classList.contains("uploaded") || false
    },

    uploadedFileNames: {
      travelerPhotoName: window.uploadedFiles?.travellerImage?.name || "",
      passportFrontName: window.uploadedFiles?.passportFront?.name || "",
      passportBackName: window.uploadedFiles?.passportBack?.name || ""
    },
    timestamp: new Date().toISOString(),
    completed: false
  };


  const hasFormData = Object.values(newData.formData).some(v => v.trim() !== "");
  const hasTravellers = newData.travellers.length > 0;
  const hasUploads = Object.values(newData.uploadStates).some(v => v === true);

  if (!hasFormData && !hasTravellers && !hasUploads) return;

  try {
    const json = JSON.stringify(newData);
    window.savedProgress = json;
    localStorage.setItem("uaeVisaProgress", json);
  } catch (e) {
    sessionStorage.setItem("uaeVisaProgress", json);
  }
}

function loadProgress() {
  try {
    let saved = window.savedProgress || localStorage.getItem("uaeVisaProgress") ;

    if (!saved) return null;

    const data = JSON.parse(saved);

    const age = (Date.now() - new Date(data.timestamp)) / (86400000);
    if (age > 7 || data.completed) {
      clearSavedProgress();
      return null;
    }
    return data;

  } catch (err) {
    clearSavedProgress();
    return null;
  }
}


function restoreProgress(data) {
   console.log("Restore Function is Running");

   // Restore travellers
   window.travellers = Array.isArray(data.travellers) ? data.travellers : [];

  // Restore login state
    userLoggedIn = Boolean(data.isUserLoggedIn);

  // Restore form values
   Object.entries(data.formData || {}).forEach(([key, value]) => {
    const el = document.getElementById(key);
    if (el) el.value = value;
   });

  // Restore upload UI
  const u = data.uploadStates || {};
  const names = data.uploadedFileNames || {};

  if (u.travelerPhotoUploaded) markAsUploaded("travelerPhotoUpload", names.travelerPhotoName);
  if (u.passportFrontUploaded) markAsUploaded("passportFrontUpload", names.passportFrontName);
  if (u.passportBackUploaded) markAsUploaded("passportBackUpload", names.passportBackName);

  // Restore uploadedFiles object safely
  window.uploadedFiles = {
    travellerImage: u.travelerPhotoUploaded ? { name: names.travelerPhotoName } : null,
    passportFront:  u.passportFrontUploaded ? { name: names.passportFrontName } : null,
    passportBack:   u.passportBackUploaded ? { name: names.passportBackName } : null
  };
  
  currentStep = data.currentStep || 1;
   showStep(currentStep);

  if (typeof update === "function") update();
   window.isRestoring=false;
   window.restoreCompleted=false;
}


function markAsUploaded(elementId, fileName) {
  const el = document.getElementById(elementId);
  if (!el) return;

  const cleanName = fileName?.replace(/^Uploaded:\s*/i, "") || "Uploaded";

  el.querySelector(".upload-text").textContent = `Uploaded: ${cleanName}`;
  el.querySelector(".upload-subtitle").textContent = "File uploaded successfully!";
  el.classList.add("uploaded");
}


function clearSavedProgress() {
  window.savedProgress = null;
  try { localStorage.removeItem("uaeVisaProgress"); } catch {}
  try { sessionStorage.removeItem("uaeVisaProgress"); } catch {}
}


// NEW SHOW PROMPT CODE
function showProgressPrompt(progressData) {
  const progressDate = new Date(progressData.timestamp).toLocaleDateString();

  const stepNames = {
    1: "Travel Dates",
    2: "Document Upload",
    3: "Type of Visa",
    4: "Additional Documents",
    5: "Review Application",
  };

  const currentStepName = stepNames[progressData.currentStep] || "Unknown Step";

  // Ensure travellers array exists
  const localStorageTraveller = Array.isArray(progressData.travellers)
    ? progressData.travellers
    : [];

  const travellersCount = localStorageTraveller.length;

  // DOM elements
  const savedProgressCard = document.getElementById("savedProgressCard");
  const progressDateEl = document.getElementById("progressDate");
  const progressStepEl = document.getElementById("progressStep");
  const progressTravellersEl = document.getElementById("progressTravellers");
  const btnProceedPayment = document.getElementById("btnProceedPayment");
  const btnResume = document.getElementById("btnResume");
  const btnStartFresh = document.getElementById("btnStartFresh");

  if (
    savedProgressCard &&
    progressDateEl &&
    progressStepEl &&
    progressTravellersEl
  ) {
    progressDateEl.textContent = `Last saved: ${progressDate}`;

    if (travellersCount > 0) {
      progressStepEl.textContent = `Travellers added: ${travellersCount}`;
      progressTravellersEl.textContent = `Total: ${travellersCount}`;
    } else {
      progressStepEl.textContent = `Step: ${currentStepName}`;
      progressTravellersEl.textContent = "Travellers: 0";
    }

    savedProgressCard.classList.remove("hidden");

    // Display sidebar travellers AFTER showing card
    if (travellersCount > 0) {
      setTimeout(() => {
        displaySidebarTravellers();
      }, 50);
    }

    // Button visibility
    if (btnProceedPayment) btnProceedPayment.style.display = "none";
    if (btnResume) btnResume.style.display = travellersCount > 0 ? "none" : "block";
  }

  // Attach button handlers safely
  if (btnResume) {
    btnResume.removeEventListener("click", resumeHandler);
    btnResume.addEventListener("click", resumeHandler);
  }

  if (btnStartFresh) {
    btnStartFresh.removeEventListener("click", startFreshHandler);
    btnStartFresh.addEventListener("click", startFreshHandler);
  }
}



function resumeHandler() {
  const savedProgressCard = document.getElementById("savedProgressCard");
  if (savedProgressCard) savedProgressCard.classList.add("hidden");

  const savedProgress = loadProgress();
  if (savedProgress) {
    restoreProgress(savedProgress);
  }
}


function startFreshHandler() {
  const savedProgressCard = document.getElementById("savedProgressCard");
  if (savedProgressCard) savedProgressCard.classList.add("hidden");

  clearSavedProgress();
  clearFormData();

  // Avoid accidental global variable leak
  window.travellers = [];
  window.userLoggedIn = false;

  showStep(1);
  update();
}


// Remove all previous listeners from Next button
function replaceButtonWithClone(btn) {
  const newBtn = btn.cloneNode(true);
  btn.parentNode.replaceChild(newBtn, btn);
  return newBtn;
}

let isRestoring=false;
// SHOW STEP FUNCTION 
function showStep(step) {
 
  if (typeof update === "function") update();

    if (!isRestoring) {
      if (typeof saveProgress === "function") saveProgress();
    }

  // Show only the selected section
  document.querySelectorAll(".form-section").forEach((sec) => {
    sec.classList.toggle("hidden", Number(sec.dataset.step) !== step);
  });

  window.scrollTo({ top: 0, behavior: "smooth" });

  // Update sidebar
  document.querySelectorAll(".sidebar-item").forEach((item) => {
    item.classList.toggle("active", Number(item.dataset.step) === step);
    item.classList.toggle("inactive", Number(item.dataset.step) !== step);
  });

  const prevBtn = document.querySelector(".prev-btn");
  if (prevBtn) prevBtn.style.display = step === 1 ? "hidden" : "inline-block";

  currentStep = step;

  let nextBtn = document.querySelector(".next-btn");
  nextBtn = replaceButtonWithClone(nextBtn);

    if (step === 5) {

    if (typeof updateReviewContent === "function") updateReviewContent();

    if (window.isEditMode === true) {
      nextBtn.textContent = "Update Traveller";
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (typeof editSavedTravellerAPI === "function") editSavedTravellerAPI(window.currentEditingIndex);
      });
    } else {
      nextBtn.textContent = "Save Traveller";
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (typeof proceedToPayment === "function") proceedToPayment();
      });
    }

    return; // STOP normal-next logic
  }

  nextBtn.textContent = "Continue";
  nextBtn.addEventListener("click", handleNextClick);
  
}


function handleNextClick() {

  if (currentStep === 5) return; 

  let valid = true;

  if (currentStep === 1) valid = validateStep1();

  else if (currentStep === 2) {
    valid = validateStep2();
    if (valid) {
      const age = document.getElementById("dob").value;
      setTimeout(() => filterCard(age), 50);
    }
  }

  else if (currentStep === 3) valid = validateStep3();
  else if (currentStep === 4) valid = validateStep4();

  if (!valid) return;

  showStep(currentStep + 1);
}


function validateField(fieldId, validationFn, errorMessage) {
  const field = document.getElementById(fieldId);
  const errorDiv = document.getElementById(fieldId + "Error");

  if (!field) return true;

  const isValid = validationFn(field.value);

  if (!isValid) {
    field.classList.add("error");
    if (errorDiv) errorDiv.textContent = errorMessage;
    return false;
  } else {
    field.classList.remove("error");
    if (errorDiv) errorDiv.textContent = "";
    return true;
  }
}


function validateMobile(value) {
  const mobileRegex = /^[6-9][0-9]{9}$/; 
  return mobileRegex.test(value.replace(/\s+/g, ""));
}


function validateEmail(value) {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(value.trim());
}



//Validate new PassportExpiry Function
function validatePassportExpiry(value) {
  if (!value) return false;

  // Try to parse the date
  const expiryDate = new Date(value);
  // Check if it's a valid date
  if (isNaN(expiryDate.getTime())) {
    return false;
  }

  // Normalize dates to ignore time of day
  expiryDate.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Compute six months from now more reliably
  const sixMonthsFromNow = new Date(today);

  // Helper: add months safely, handling end-of-month
  function addMonths(date, months) {
    const d = date.getDate();
    date.setMonth(date.getMonth() + months);
    if (date.getDate() < d) {
      date.setDate(0);
    }
    return date;
  }

  addMonths(sixMonthsFromNow, 6);

  return expiryDate > sixMonthsFromNow;
}

// START DATE MIN = Tomorrow
const today = new Date();
today.setDate(today.getDate() + 1);
const startMin = today.toISOString().split("T")[0];

document.getElementById("travelStartDate").setAttribute("min", startMin);

document.getElementById("travelStartDate").addEventListener("change", function () {
    const startDate = new Date(this.value);
    if (!this.value || isNaN(startDate.getTime())) return;
    startDate.setDate(startDate.getDate() + 1);
    const endMin = startDate.toISOString().split("T")[0];
    document.getElementById("travelEndDate").setAttribute("min", endMin);
});



function validateTravelStartDate(value) {
  if (!value) return false;
  const startDate = new Date(value);
  const today = new Date();
    // Check if date is valid
  if (isNaN(startDate.getTime())) return false;
  
  // Set today's time to start of day for comparison
  today.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  
  // Calculate minimum allowed date based on additionalDays
  const minAllowedDate = new Date(today);
  minAllowedDate.setDate(minAllowedDate.getDate() + additionalDays);
  
  // Travel date should not be more than 1 year in advance
  const oneYearFromNow = new Date(today);
  oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

  return startDate >= minAllowedDate && startDate <= oneYearFromNow;
}

function validateTravelEndDate(value) {
  if (!value) return false;
  const endDate = new Date(value);
  const today = new Date();
  const startDateValue = document.getElementById("travelStartDate")?.value;
  
  // Check if date is valid
  if (isNaN(endDate.getTime())) return false;
  
  // Set time to start of day for comparison
  today.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  
  // Calculate minimum allowed date based on additionalDays
  const minAllowedDate = new Date(today);
  minAllowedDate.setDate(minAllowedDate.getDate() + additionalDays);
  
  // End date must be in the future (respecting additionalDays)
  if (endDate < minAllowedDate) return false;
  
  if (!startDateValue) return true; 
  
  const startDate = new Date(startDateValue);
  if (isNaN(startDate.getTime())) return true;
  
  startDate.setHours(0, 0, 0, 0);
  
  // End date must be after start date
  if (endDate <= startDate) return false;
  
  // End date should not be more than 60 days from start date (visa validity)
  const maxEndDate = new Date(startDate);
  maxEndDate.setDate(maxEndDate.getDate() + 60);
  
  return endDate <= maxEndDate;
}

function updateTravelDays() {
  const start = document.getElementById("travelStartDate")?.value;
  const end   = document.getElementById("travelEndDate")?.value;
  
  if (!validateTravelStartDate(start) || !validateTravelEndDate(end)) {
    selectedData['travelDays'] = null; 
    return;
  }
  const diffDays = getDateDifferenceInDays(start, end);
  if (diffDays === null) return;
  selectedData['travelDays'] = diffDays <= 30 ? 30 : 60;
}

function getDateDifferenceInDays(start, end) {
  if (!start || !end) return null;

  const startDate = new Date(start);
  const endDate = new Date(end);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return null;

  const utcStart = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const utcEnd   = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  const diffMs = utcEnd - utcStart;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  console.log("Difference in date",diffDays);
  return diffDays;
}

function validateDateOfBirth(value) {
  if (!value) return false;
  const dobDate = new Date(value);
  const today = new Date();
  // Check if date is valid
  if (isNaN(dobDate.getTime())) return false;

  // Check if date is not in future
  if (dobDate > today) return false;
  let age = today.getFullYear() - dobDate.getFullYear();
  const monthDiff = today.getMonth() - dobDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < dobDate.getDate())
  ) {
    age--;
  }

  return age >= 0 && age <= 100;
}

function validatePassportNumber(value) {
  // Basic passport number validation (alphanumeric, 6-10 characters)
  const passportRegex = /^[A-Z0-9]{6,10}$/;
  return passportRegex.test(value.toUpperCase().replace(/\s+/g, ""));
}

function validateName(value) {
  // Name should contain only letters, spaces, hyphens, and apostrophes
  const nameRegex = /^[a-zA-Z\s\-.']{2,50}$/;
  return nameRegex.test(value.trim());
}

function validateStep1() {
  
   let allValid = true;

  const continueBtn = document.getElementById('step1ContinueBtn');
  const radiosVisit = document.querySelectorAll('input[name="visit-purpose"]');
  // const radiosDays = document.querySelectorAll('input[name="numberofdays"]');

  // const visitSelected = Array.from(radiosVisit).some(r => r.checked);
  // const daysSelected = Array.from(radiosDays).some(r => r.checked);

  // if (!visitSelected){
  //   alert("Please select Purpose of Visit");
  //   $('#purposeOfVisitSection .card').addClass('error-card');
  //   document.querySelector('#purposeOfVisitSection .card-container').scrollIntoView({ behavior: 'smooth' });
  // }
  //  if (!daysSelected){
  //   alert("Please select Number of Days You want to Stay");
  //   $('#purposeOfVisitSection .num-day').addClass('error-card');
  //   document.querySelector('#purposeOfVisitSection .days-container').scrollIntoView({ behavior: 'smooth' });

  // }
  // allValid = ( daysSelected)
  // allValid = (visitSelected && daysSelected)
  // selectedData['purpose'] = $('input[name="visit-purpose"]:checked').val();
  // selectedData['purpose'] = $('input[name="visit-purpose"]:checked').val();
  // selectedData['travelDays'] = $('input[name="numberofdays"]:checked').val();

      // Travel dates validation
    allValid &&= validateField(
      "travelStartDate",
       validateTravelStartDate,
      `Travel start date must be at least ${additionalDays} day(s) from today`
      );
    allValid &&= validateField(
      "travelEndDate",
       validateTravelEndDate,
     `Travel end date must be after start date and at least ${additionalDays} day(s) from today`
     );
     if(allValid){
       updateTravelDays();
     }else{
      // alert("Please Enter Travel Dates");
      return;
     }
  // preselect adult as the price option
  document.querySelectorAll('.visa-card').forEach(card => {
    const groupKey = card.dataset.group;
    const priceOptions = card.querySelectorAll('.dropdown-content p');

    if (!priceOptions.length) return;

    // Try to find 'Adult' option
    let adultOption = Array.from(priceOptions).find(p => p.textContent.trim().startsWith("Adult"));

    // If 'Adult' not found, select the first one
    let defaultOption = adultOption || priceOptions[0];

    if (defaultOption) {
      // Extract data from the onclick call in a safe way
      const onclickValue = defaultOption.getAttribute('onclick');
      const args = onclickValue.match(/'([^']*)'/g)?.map(a => a.replace(/'/g, ''));

      if (args && args.length >= 4) {
        const [value, variantId, group, ageGroup] = args;
        selectPrice(value, variantId, group, ageGroup);
      }
    }
  });
  if (allValid){
    if (!currentUser){
      showAuthModal("signup");
      localStorage.setItem("visaStartDate", $('#travelStartDate').val());
      localStorage.setItem("visaEndDate", $('#travelEndDate').val());
      return;
    }
  }
  return allValid;
}

function validateStep2() {
  let allValid = true;

  const photoUploaded = document.getElementById("travelerPhotoUpload").classList.contains("uploaded");
  const frontUploaded = document.getElementById("passportFrontUpload").classList.contains("uploaded");
  const backUploaded = document.getElementById("passportBackUpload").classList.contains("uploaded");

  // Basic validations
  allValid &&= validateField("Title", validateName, "Please select a valid Title");

  allValid &&= validateField("FirstName", validateName, "First name is required");
  allValid &&= validateField("LastName", validateName, "Last name is required & contain only letters");

  const middleName = document.getElementById("middleName")?.value.trim();

  if (middleName){
      allValid &&= validateField( "middleName", validateName, "Middle name should contain only letters");
      }

  allValid &&= validateField("gender", (v) => v.trim().length > 0, "Please select gender");
  allValid &&= validateField("occupation", (v) => v.trim().length > 0, "Please select occupation");

  allValid &&= validateField("passportNumber", validatePassportNumber, "Passport number is required");
  allValid &&= validateField("mobile", validateMobile, "Please enter a valid 10-digit mobile number");
  allValid &&= validateField("email", validateEmail, "Please enter a valid email address");
  allValid &&= validateField("dob", validateDateOfBirth, "Please enter a valid date of birth");
   
  allValid &&= validateField("passportExpiry", validatePassportExpiry, "Passport Validity should be minimum 6 months");

  // Passport uploads check
  if (!frontUploaded || !backUploaded || !photoUploaded) {
    // alert("Please upload Passport Front, Back, and Traveler Photo.");
    showPopup("Please Upload All Images")
    allValid = false;
  }

  // return allValid;
  return true;;
}

function validateStep3() {
  let allValid = false;
  $('.error-visa-card').removeClass('error-visa-card');
  if ($('.visa-card-active:visible').length > 0) {
    allValid = true;
  }
  else{
    // alert("Please select a type of VISA");
    showPopup("Please Select a type of Visa");
    $('.visa-card').addClass('error-visa-card');
    document.querySelector('#visaTypeSection .visa-card').scrollIntoView({ behavior: 'smooth' });
  }

  if (allValid){
    const $activeCard = $('.visa-card-active');
    selectedData['visaValidity'] = $activeCard.data('validity');
    selectedData['price']        = $activeCard.data('selectedPrice');
    selectedData['entryType']    = $activeCard.data('entryType');
    selectedData['ageGroup']     = $activeCard.data('ageGroup');
    selectedData['stayPeriod']   = $activeCard.data('stayPeriod');
    selectedData['variantId']    = $activeCard.data('selectedVariant');
    selectedData['processingType'] = $activeCard.data('processingType');
    selectedData['deliveryType'] = $activeCard.data('deliveryType');
    selectedData['visaFee'] = $activeCard.data('visaFee');
    selectedData['govtFee'] = $activeCard.data('govtFee');
    selectedData['serviceTax'] = $activeCard.data('serviceTax');
    selectedData['matrixGovtFee'] = $activeCard.data('matrixGovtFee');
    selectedData['matrixFee'] = $activeCard.data('matrixFee');
  }
  return allValid;
}

function validateStep4() {
  const flightFile = document.getElementById("flightFile");
  const errorDiv = document.getElementById("flightFileError");
  const uploadCard = document.querySelector(".upload-card");

  // Check if file exists
  if (!flightFile.files.length) {
    errorDiv.textContent = "Flight ticket is required";
    flightFile.classList.add("error");
    return false;
  }

  // Check if previous handler marked it uploaded (valid)
  if (!uploadCard.classList.contains("uploaded")) {
    errorDiv.textContent = "Please upload a valid PDF under 5MB";
    flightFile.classList.add("error");
    return false;
  }

  // Everything good
  errorDiv.textContent = "";
  flightFile.classList.remove("error");
  return true;
}


function handleFlightFileChange() {
  const flightFile = document.getElementById("flightFile");
  const errorDiv = document.getElementById("flightFileError");
  const uploadSubtitle = document.querySelector(".upload-card .upload-subtitle");
  const uploadCard = document.querySelector(".upload-card");

  if (!flightFile.files.length) {
    uploadSubtitle.textContent = "Upload your confirmed flight booking";
    uploadCard.classList.remove("uploaded");
    return;
  }

  const file = flightFile.files[0];
  const maxSize = 5 * 1024 * 1024; 

  // PDF only
  if (file.type !== "application/pdf") {
    errorDiv.textContent = "Only PDF is allowed";
    flightFile.classList.add("error");
    uploadCard.classList.remove("uploaded");
    uploadSubtitle.textContent = "Upload your confirmed flight booking";
    return;
  }

  if (file.size > maxSize) {
    errorDiv.textContent = "File must be less than 5MB";
    flightFile.classList.add("error");
    uploadCard.classList.remove("uploaded");
    return;
  }

  // VALID FILE — update UI instantly
  errorDiv.textContent = "";
  flightFile.classList.remove("error");
  uploadSubtitle.innerText = file.name;
  uploadCard.classList.add("uploaded");
}
document.getElementById("flightFile").addEventListener("change",handleFlightFileChange);

 
 const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];
 const MAX_SIZE = 5 * 1024 * 1024; // 5MB

document.querySelectorAll('.photo-upload input[type="file"]').forEach(input => {
  input.addEventListener('change', event => {
    const file = event.target.files[0];
    const container = event.target.closest('.photo-upload');
    const img = container.querySelector('img');
    const errorDiv = container.querySelector('.error-message');

     if(!file) return;

      if (file) {
      // Validate before preview
      if (!ALLOWED_TYPES.includes(file.type)) {
        if (errorDiv) errorDiv.textContent = "Only JPG or PNG images are allowed";
        // if (img) img.src = "error-icon.png"; // optional fallback
        return;
      } 
      if (file.size > MAX_SIZE) {
        if (errorDiv) errorDiv.textContent = "File must be less than 5MB";
        // if (img) img.src = "error-icon.png";
        return;
      }

      // Clear any old error
      if (errorDiv) errorDiv.textContent = "";

      // Show image preview
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = e => {
          if (img) img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    }
  });
});


// Mobile step viewer or counter
const progress = document.getElementById('progress');
const circles = document.querySelectorAll('.circle');
function  update(){
  // 1. Update the 'active' class on the circles (Green color)
    circles.forEach((circle, idx) => {
               if (idx < currentStep) {
                    circle.classList.add('active'); 
                 } else {
                    circle.classList.remove('active'); 
                }
            });
            const progressPercent = ((currentStep - 1) / 4) * 100;
            progress.style.width = progressPercent + '%';
          }
            

function updateReviewContent() {
  const title = document.getElementById("title").value || "";
  const firstName = document.getElementById("firstName").value || "";
  const lastName = document.getElementById("lastName").value || "";
  const email = document.getElementById("email").value || "";
  const mobile = document.getElementById("mobile").value || "";

  const travelStartDateElement = document.getElementById("travelStartDate");
  const travelEndDateElement = document.getElementById("travelEndDate");

  const travelStartDate = travelStartDateElement ? travelStartDateElement.value : "";
  const travelEndDate = travelEndDateElement ? travelEndDateElement.value : "";

  const reviewContent = document.getElementById("reviewContent");
  if (reviewContent) {
    reviewContent.innerHTML = `
      <div style="margin-bottom: 1rem;"><strong>Name:</strong> ${title}. ${firstName} ${lastName}</div>
      <div style="margin-bottom: 1rem;"><strong>Email:</strong> ${email}</div>
      <div style="margin-bottom: 1rem;"><strong>Mobile:</strong> ${mobile}</div>
      <div style="margin-bottom: 1rem;">
        <strong>Travel Dates:</strong>
        ${
          travelStartDate
            ? new Date(travelStartDate).toLocaleDateString()
            : "Not specified"
        } to ${
      travelEndDate
        ? new Date(travelEndDate).toLocaleDateString()
        : "Not specified"
    }
      </div>
      <div style="margin-bottom: 1rem;">
        <strong>Documents:</strong> Passport (Front & Back), Traveler Photo, Flight Ticket, Hotel Booking,
      </div>
      ${getUploadedDocuments()}
    `;
  }
}


function getUploadedDocuments() {
  const docs = [];

  const passportFront = document.getElementById("passportFrontUpload");
  const passportBack = document.getElementById("passportBackUpload");
  const travelerPhoto = document.getElementById("travelerPhotoUpload");

  const flightFile = document.getElementById("flightFile");
  const hotelFile = document.getElementById("hotelFile");
  // const bankFile = document.getElementById("bankFile");

  const uploadedDocs = [
    {
      name: "Passport",
      uploaded: passportFront?.classList.contains("uploaded") && passportBack?.classList.contains("uploaded"),
     placeholder:window.assetUrl.passport
    },
    {
      name: "Traveler Photo",
      uploaded: travelerPhoto?.classList.contains("uploaded"),
       placeholder:window.assetUrl.profile
    },
    {
      name: "Flight Ticket",
      uploaded: flightFile && flightFile.files.length > 0,
      placeholder:window.assetUrl.flight
    },
    {
      name: "Hotel Booking",
      uploaded: hotelFile && hotelFile.files.length > 0,
      placeholder:window.assetUrl.hotel
    
    },
    // {
    //   name: "Bank Statement",
    //   uploaded: bankFile && bankFile.files.length > 0,
    //   placeholder:window.assetUrl.bankStatement
    // }
  ];

  //  build HTML layout
  let html = `<div class="document-preview" style="display:flex;flex-wrap:wrap;gap:10px;margin-top:15px; justify-content:center">`;

  uploadedDocs.forEach(doc => {
    const iconSrc=doc.uploaded ? window.assetUrl.tick : window.assetUrl.cross;
    
    html += `
   <div style="width:85px;text-align:center;position:relative;font-family:'Inter',sans-serif;">
  <div style="position:relative;">
    <img src="${doc.placeholder}" alt="${doc.name}"
      style="width:100%;height:70px;object-fit:cover;border-radius:8px;mix-blend-mode:multiply;
             background-color:#fff; box-shadow:0 1px 3px rgba(0,0,0,0.08);">
    <div style="position:absolute;bottom:4px;right:2px;
                border-radius:50%;width:14px;height:14px;display:flex;
                align-items:center;justify-content:center;
                box-shadow:0 1px 3px rgba(0,0,0,0.15);">
      <img src=${iconSrc} style="width:14px;height:14px;" />
    </div>
  </div>
  <div style="margin-top:6px;font-size:12px;font-weight:500;color:#333;
              white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
    ${doc.name}
  </div>
</div> `;
  });

  html += `</div>`;
  return html;
}


  function filterCard(dob){
      let count=0;
      const age= calculateAgeFromDOB(dob);  //age =19
      const cardStay=selectedData["travelDays"];  // 30 
       const noPlansMsg = document.getElementById("noPlansMessage");
      const allCards=document.querySelectorAll('.visa-card');
      allCards.forEach(card => {
        const minAge=parseInt(card.dataset.minimumAge || "0");
        const maxAge=parseInt(card.dataset.maximumAge || "150");
        const travel=parseInt(card.dataset.stayPeriod || "0");
        const ageValid = age >= minAge && age <= maxAge;
        const daysValid = cardStay === travel;
  
        if(ageValid && daysValid){
          card.style.display="flex";
          count++;
        }else{
          card.style.display="none";
        }
      });  

      if (count === 0) {
          noPlansMsg.classList.remove("hidden");
      } else {
         noPlansMsg.classList.add("hidden");
    }
  }

// Canonical JSON String - sorts keys alphabetically and creates proper JSON format
function canonicalJSONString(fields) {
  // Sort the keys alphabetically
  const sortedKeys = Object.keys(fields).sort();
  let parts = [];

  sortedKeys.forEach((k) => {
    // Preserve spaces in values
    let value = fields[k] == null ? "" : fields[k].toString();
    // Escape quotes inside string values
    value = value.replace(/"/g, '\\"');
    parts.push(`"${k}":"${value}"`);
  });

  // combine all the keys as string without any space (except in values)
  return `{${parts.join(",")}}`;
}

// Function to fetch passport data using API
async function fetchPassportDataFromAPI() {
 
  if (window.passportDataFetched) {
    return;
  }
  console.log("Triggering API to fetch passport data...");
  window.passportDataFetched = true;

  const personalDetailsSection = document.getElementById(
    "personalDetailsSection"
  );

  if (personalDetailsSection) {
    // Hide all form content initially
    const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
    const headings = personalDetailsSection.querySelectorAll("h3");
    formGrids.forEach((grid) => (grid.style.display = "none"));
    headings.forEach((heading) => (heading.style.display = "none"));

    const loadingDiv = document.createElement("div");
    loadingDiv.id = "apiLoadingIndicator";
    loadingDiv.style.cssText =
      "background: #eff6ff; border: 1px solid #3b82f6; color: #1e40af; padding: 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;";
    loadingDiv.innerHTML =
      "<strong>Processing passport images...</strong><br><small>Extracting information from your documents</small>";
    personalDetailsSection.insertBefore(
      loadingDiv,
      personalDetailsSection.firstChild
    );
  }
  // Fetch text-only fields (empty object for this API)
  let textFields = {};

  // Fetch Stringified JSON, sorted and without spaces between keys
  const bodyText = canonicalJSONString(textFields);

  // Get Timestamp and Create HMAC encode string
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.API_ENDPOINT;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  // Compute HMAC using CryptoJS Library
  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );

  // Fetch Form Data and append the hash data as a parameter
  console.log(uploadedFiles, "uploaded files");
  let formData = new FormData();
  formData.append("passportFront", uploadedFiles.passportFront);
  formData.append("passportBack", uploadedFiles.passportBack);
  formData.append("travellerImage", uploadedFiles.travellerImage);
  formData.append("hash_data", hashData);

  console.log(formData, "formdattta");
  // Send AJAX with headers (timestamp only in header, not body)
  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}?success=1`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: function (resp) {
      console.log("Success:", resp);

      // Remove loading indicator
      const loadingDiv = document.getElementById("apiLoadingIndicator");
      if (loadingDiv) {
        loadingDiv.remove();
      }
      // Prepopulate and mark as required based on API response
      const setFieldValue = (id, value) => {
        const el = document.getElementById(id);
        if (el) {
          el.value = value;
          el.required = true; // 👈 mark as required
          el.classList.add("required-highlight"); // optional visual cue
        }
      };

      if (resp?.data?.passportNumber) {
        setFieldValue("passportNumber", resp.data.passportNumber);
      }

      if (resp?.data?.travellerFirstName) {
        setFieldValue("firstName", resp.data.travellerFirstName);
      }

      if (resp?.data?.travellerTitle) {
        setFieldValue("title", resp.data.travellerTitle);
      }

      if (resp?.data?.travellerMiddleName) {
        setFieldValue("middleName", resp.data.travellerMiddleName);
      }

      if (resp?.data?.travellerLastName) {
        setFieldValue("lastName", resp.data.travellerLastName);
      }

      if (resp?.data?.gender) {
        document.getElementById("gender").value =
          resp?.data?.gender.toLowerCase();
      }

      if (resp?.data?.travellerDob) {
        // Convert DD-MM-YYYY to YYYY-MM-DD
        const dobParts = resp?.data?.travellerDob.split("-");
        if (dobParts.length === 3) {
          const formattedDob = `${dobParts[2]}-${dobParts[1]}-${dobParts[0]}`;
          document.getElementById("dob").value = formattedDob;
        }
      }

      if (resp?.data?.passportExpiry) {
        // Convert DD-MM-YYYY to YYYY-MM-DD
        const expiryParts = resp?.data?.passportExpiry.split("-");
        if (expiryParts.length === 3) {
          const formattedExpiry = `${expiryParts[2]}-${expiryParts[1]}-${expiryParts[0]}`;
          document.getElementById("passportExpiry").value = formattedExpiry;
        }
      }

      // Show success message
      const successDiv = document.createElement("div");
      successDiv.style.cssText =
        "background: #ecfdf5; border: 1px solid #10b981; color: #047857; padding: 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;";
      successDiv.innerHTML =
        "<strong>Documents processed successfully!</strong><br><small>Please review and complete the form below</small>";
      personalDetailsSection.insertBefore(
        successDiv,
        personalDetailsSection.firstChild
      );
  
          // Show form fields
          const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
          const headings = personalDetailsSection.querySelectorAll("h3");
          formGrids.forEach((grid) => (grid.style.display = "grid"));
          headings.forEach((heading) => (heading.style.display = "block"));
    
          // Remove success message after 5 seconds
          setTimeout(() => {
            successDiv.remove();
          }, 5000);
    },
    error: function (xhr) {
      console.error("Error:", xhr.responseText);

      // Remove loading indicator
      const loadingDiv = document.getElementById("apiLoadingIndicator");
      if (loadingDiv) {
        loadingDiv.remove();
      }

      // Show error message
      const errorDiv = document.createElement("div");
      errorDiv.style.cssText =
        "background: #fee2e2; border: 1px solid #ef4444; color: #991b1b; padding: 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;";
      errorDiv.innerHTML = `<strong>Error processing documents</strong><br><small>${
        xhr.responseText || "Please try again"
      }</small>`;
      personalDetailsSection.insertBefore(
        errorDiv,
        personalDetailsSection.firstChild
      );

    },
  });
}
// Fetch saved travellers from API
async function fetchSavedTravellers() {
  if (!userLoggedIn || !currentUser?.email) {
    console.log("User not logged in, skipping fetch saved travellers");
    return;
  }

  const textFields = {
    customerEmail: currentUser?.email,
  };

  // Get Timestamp and Create HMAC
  const bodyText = canonicalJSONString(textFields);
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.GET_TRAVELLER_LIST;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );

  console.log("hash_data:", hashData);
  let formData = new FormData();
  formData.append("customerEmail", currentUser?.email);
  formData.append("hash_data", hashData);

  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: function (response) {
      console.log("[Saved Traveller] -->", response );
      if (response.status === 1 && response?.data && response.data.length > 0) {
        displaySavedTravellers(response.data);

        // const travellersWithId = response.data.map((user) => ({
        //   ...user,
        //   travellerId: user.id || null ,
        // }));
      } else {
        console.log("No saved travellers found");
        hideSavedTravellersSection();
      }
    },
    error: function (xhr) {
      console.error("Error:", xhr.responseText);
      hideSavedTravellersSection();
    },
  });
}

// // Edit saved traveller API call
async function editSavedTravellerAPI(index) {
   console.log("editSavedTravellerAPI called with index:", index);
 
  if (!window.travellers[index]) return;

  const traveller = window.travellers[index];
  console.log("Editing traveller:", traveller);
  // Check if traveller has travellerId
  if (!traveller.travellerId) {
    alert("Error: Traveller ID not found. Cannot edit this traveller.");
    return;
  }

  // Show loading
  const loadingOverlay = document.createElement("div");
  loadingOverlay.id = "editLoadingOverlay";
  loadingOverlay.style.cssText =
    "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999;";
  loadingOverlay.innerHTML = `
    <div style="background: white; padding: 2rem; border-radius: 12px; text-align: center; max-width: 400px;">
      <div style="font-size: 2rem; margin-bottom: 1rem;">⏳</div>
      <h3 style="margin-bottom: 0.5rem;">Updating Traveller</h3>
      <p style="color: #64748b;">Please wait...</p>
    </div>
  `;
  document.body.appendChild(loadingOverlay);

  // Collect form data - get updated values from form
  const textFields = {
    customerEmail: currentUser?.email || "",
    travellerId: traveller.travellerId,
    travellerTitle:
      document.getElementById("title")?.value ||
      traveller.travellerTitle,
    travellerFirstName:
      document.getElementById("firstName")?.value ||
      traveller.travellerFirstName,
    travellerMiddleName:
      document.getElementById("middleName")?.value ||
      traveller.travellerMiddleName ||
      "",
    travellerLastName:
      document.getElementById("lastName")?.value || traveller.travellerLastName,
    travellerEmail:
      document.getElementById("email")?.value || traveller.travellerEmail ,
    travellerMobile:
      document.getElementById("mobile")?.value || traveller.travellerMobile,
    travellerDob:
      document.getElementById("dob")?.value || traveller.travellerDob,
    travellerCity: "",
    travellerState: "",
    travellerPincode: "",
    travellerAddressLine1: "",
    travellerAddressLine2: "",
    passportNumber:
      document.getElementById("passportNumber")?.value ||
      traveller.passportNumber,
  };

  // Validate required fields
  if (!textFields.customerEmail) {
    alert("Customer email is required. Please login again.");
    const overlay = document.getElementById("editLoadingOverlay");
    if (overlay) overlay.remove();
    return;
  }

  // Create canonical JSON string
  const bodyText = canonicalJSONString(textFields);

  // Get Timestamp and Create HMAC
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.EDIT_TRAVELLER;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  console.log("Edit Traveller - Signing message:", message);

  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );

  console.log("Edit Traveller - hash_data:", hashData);

  // Prepare FormData
  let formData = new FormData();
  Object.keys(textFields).forEach((key) => {
    formData.append(key, textFields[key]);
  });
  formData.append("hash_data", hashData);

  // Send AJAX
  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: async function (resp) {
      console.log("Edit Traveller Success:", resp);

      // Remove loading overlay
      const overlay = document.getElementById("editLoadingOverlay");
      if (overlay) overlay.remove();

      if (resp.status === 1) {
        // Reset edit mode flags
        window.editingTravellerIndex = null;
        window.editingTravellerData = null;
        window.isEditMode = false;
        // Clear form
        clearFormData();
        showStep(1);
        // Show success message
        alert("Traveller updated successfully!");
        // Refresh travellers list
        await fetchSavedTravellers();
        // Scroll to top to show updated list
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        alert(resp.message || "Failed to update traveller");
      }
    },
    error: function (xhr) {
      console.error("Edit Traveller Error:", xhr.responseText);

      const overlay = document.getElementById("editLoadingOverlay");
      if (overlay) overlay.remove();

      let errorMsg = "Error updating traveller";
      try {
        const errorResp = JSON.parse(xhr.responseText);
        errorMsg = errorResp.message || errorMsg;
      } catch (e) {
        errorMsg = xhr.responseText || errorMsg;
      }

      alert(errorMsg);
    },
  });
}

// Delete saved traveller API call
async function deleteSavedTravellerAPI(index) {
  if (!window.savedTravellersData || !window.savedTravellersData[index]) return;

  const traveller = window.savedTravellersData[index];

  // Check if traveller has travellerId
  if (!traveller.travellerId) {
    alert("Error: Traveller ID not found. Cannot delete this traveller.");
    return;
  }

  const confirmed = confirm(
    `Are you sure you want to delete:\n${traveller.travellerFirstName} ${traveller.travellerLastName}?`
  );

  if (!confirmed) return;

  // Show loading
  const loadingOverlay = document.createElement("div");
  loadingOverlay.id = "deleteLoadingOverlay";
  loadingOverlay.style.cssText =
    "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999;";
  loadingOverlay.innerHTML = `
    <div style="background: white; padding: 2rem; border-radius: 12px; text-align: center; max-width: 400px;">
      <div style="font-size: 2rem; margin-bottom: 1rem;">⏳</div>
      <h3 style="margin-bottom: 0.5rem;">Deleting Traveller</h3>
      <p style="color: #64748b;">Please wait...</p>
    </div>
  `;
  document.body.appendChild(loadingOverlay);

  // Collect form data
  const textFields = {
    customerEmail: currentUser?.email || "",
    travellerId: traveller.travellerId,
  };

  // Validate required fields
  if (!textFields.customerEmail) {
    alert("Customer email is required. Please login again.");
    const overlay = document.getElementById("deleteLoadingOverlay");
    if (overlay) overlay.remove();
    return;
  }

  // Create canonical JSON string
  const bodyText = canonicalJSONString(textFields);

  // Get Timestamp and Create HMAC
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.DELETE_TRAVELLER;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  console.log("Delete Traveller - Signing message:", message);

  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );

  console.log("Delete Traveller - hash_data:", hashData);

  // Prepare FormData
  let formData = new FormData();
  Object.keys(textFields).forEach((key) => {
    formData.append(key, textFields[key]);
  });
  formData.append("hash_data", hashData);

  // Send AJAX
  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: async function (resp) {
      console.log("Delete Traveller Success:", resp);

      // Remove loading overlay
      const overlay = document.getElementById("deleteLoadingOverlay");
      if (overlay) overlay.remove();

      if (resp.status === 1) {
        alert("Traveller deleted successfully!");

        // Refresh travellers list
        await fetchSavedTravellers();
      } else {
        alert(resp.message || "Failed to delete traveller");
      }
    },
    error: function (xhr) {
      console.error("Delete Traveller Error:", xhr.responseText);

      const overlay = document.getElementById("deleteLoadingOverlay");
      if (overlay) overlay.remove();

      let errorMsg = "Error deleting traveller";
      try {
        const errorResp = JSON.parse(xhr.responseText);
        errorMsg = errorResp.message || errorMsg;
      } catch (e) {
        errorMsg = xhr.responseText || errorMsg;
      }

      alert(errorMsg);
    },
  });
}

// Display saved travellers in grid
function displaySavedTravellers(travellersData) {
  console.log("[Display Traveller ]-->",travellersData);
  const section = document.getElementById("savedTravellersSection");
  const list = document.getElementById("savedTravellersList");

  if (!section || !list) return;

  list.innerHTML = travellersData
    .map(
      (traveller) => `
    <div class="saved-traveller-row" data-index="${traveller.id}">
      <div class="saved-traveller-checkbox">
        <input type="radio" 
              name="selectedTraveller"
               id="savedTraveller${traveller.id}" 
               onchange="toggleTravellerSelection('${traveller.id}')"
               data-index="${traveller.id}">
      </div>
      <div class="saved-traveller-content">
        <div class="saved-traveller-field">
          <span class="saved-traveller-label">Name</span>
          <span class="saved-traveller-value">${traveller.travellerTitle}. ${traveller.travellerFirstName} ${traveller.travellerLastName}</span>
        </div>
        <div class="saved-traveller-field">
          <span class="saved-traveller-label">Email</span>
          <span class="saved-traveller-value">${traveller.travellerEmail}</span>
        </div>
        <div class="saved-traveller-field">
          <span class="saved-traveller-label">Mobile</span>
          <span class="saved-traveller-value">${traveller.travellerMobile}</span>
        </div>
        <div class="saved-traveller-field">
          <span class="saved-traveller-label">Passport</span>
          <span class="saved-traveller-value passport">${traveller.passportNumber}</span>
        </div>
      </div>
      <div class="saved-traveller-actions-btns">
        <button class="saved-traveller-btn edit" onclick="editSavedTraveller('${traveller.id}')" title="Edit">
          ✏️
        </button>
        <button class="saved-traveller-btn delete" onclick="deleteSavedTraveller('${traveller.id}')" title="Delete">
          🗑️
        </button>
      </div>
    </div>
  `
    )
    .join("");

  // Store travellers data globally
  window.savedTravellersData = travellersData;
  console.log("WINDOW SAVED TRAVELLER DATA",window.savedTravellersData);
  window.selectedTravellerIndex = null;

  // Show section
  section.classList.remove("hidden");

  // Update button state
  updateContinueButton();
}

// Hide saved travellers section
function hideSavedTravellersSection() {
  const section = document.getElementById("savedTravellersSection");
  if (section) {
    section.classList.add("hidden");
  }
}

function toggleTravellerSelection(travellerId) {
  const radio = document.getElementById(`savedTraveller${travellerId}`);
  const allRows = document.querySelectorAll('.saved-traveller-row');

  if (!radio) return;

  // Remove selected class from all rows
  allRows.forEach(row => row.classList.remove('selected'));

  // Check the radio button
  radio.checked = true;

  // Add selected class to clicked row
  const row = document.querySelector(`.saved-traveller-row[data-index="${travellerId}"]`);
  if (row) {
    row.classList.add('selected');
    window.selectedTravellerIndex = travellerId;
  } else {
    window.selectedTravellerIndex = null;
  }

  updateContinueButton();
}


// Update continue button state
function updateContinueButton() {
  const btn = document.getElementById("btnContinueWithSelected");
   //const countSpan = document.getElementById("selectedCount");

  if (!btn ) return;

  if (window.selectedTravellerIndex !== null && window.selectedTravellerIndex !== undefined) {
    btn.style.display = "block";
  } else {
    btn.style.display = "none";
  }
}
 

// ===============================================
// EDIT SAVED TRAVELLER – using travellerId
// ===============================================
function editSavedTraveller(travellerId) {
  console.log("[Editing Saved Traveller] -->", travellerId);

  if (!window.savedTravellersData || !Array.isArray(window.savedTravellersData)) {
    console.error("savedTravellersData missing!");
    return;
  }

  // Find traveller by travellerId
  const traveller = window.savedTravellersData.find(t => t.id === travellerId);

  if (!traveller) {
    console.error("Traveller not found for ID:", travellerId);
    return;
  }

  // Save editing mode state
  window.isEditMode = true;
  window.editingTravellerId = travellerId;
  window.editingTravellerData = traveller;

  showAddNewTravellerForm();

  // Pre-fill traveller form fields
  document.getElementById("title").value = traveller.travellerTitle || "";
  document.getElementById("firstName").value = traveller.travellerFirstName || "";
  document.getElementById("middleName").value = traveller.travellerMiddleName || "";
  document.getElementById("lastName").value = traveller.travellerLastName || "";
  document.getElementById("email").value = traveller.travellerEmail || "";
  document.getElementById("mobile").value = traveller.travellerMobile || "";
  document.getElementById("passportNumber").value = traveller.passportNumber || "";
  document.getElementById("dob").value = traveller.travellerDob || "";
  document.getElementById("gender").value = traveller.gender || "";
  document.getElementById("occupation").value = traveller.occupation || "";
  document.getElementById("passportExpiry").value = traveller.passportExpiry || "";

  // Show personal details section
  const personalDetailsSection = document.getElementById("personalDetailsSection");
  if (personalDetailsSection) {
    personalDetailsSection.style.display = "block";
    personalDetailsSection.querySelectorAll(".form-grid").forEach(g => g.style.display = "grid");
    personalDetailsSection.querySelectorAll("h3").forEach(h => h.style.display = "block");
  }
}



function showAddNewTravellerForm() {
  const section = document.getElementById("savedTravellersSection");
  const detailsForm = document.getElementById("travellerDetailsForm");

  if (section) section.classList.add("hidden");
  if (detailsForm) detailsForm.classList.remove("hidden");

  // Clear traveller selection
  document.querySelectorAll('input[name="selectedTraveller"]').forEach(r => r.checked = false);
  document.querySelectorAll(".saved-traveller-row").forEach(r => r.classList.remove("selected"));

  window.selectedTravellerIndex = null;

  // Only reset on NEW traveller creation
  if (!window.isEditMode) {
    window.editingTravellerId = null;
    window.editingTravellerData = null;
  }

  window.scrollTo({ top: 0, behavior: "smooth" });
}


// Delete saved traveller - Call API
function deleteSavedTraveller(index) {
  deleteSavedTravellerAPI(index);
}


function continueWithSelectedTravellers() {

  console.log("clicked Continue with selected Traveller");

  const travellerId = window.selectedTravellerIndex;

  if (!travellerId) {
    alert("Please select a traveller");
    return;
  }

  // Find traveller using travellerId
  const traveller = window.savedTravellersData.find(t => t.id === travellerId);

  if (!traveller) {
    console.error("Traveller not found for ID:", travellerId);
    alert("Unable to load traveller data.");
    return;
  }

  console.log("Loaded Traveller:", traveller);

  // Pre-fill form
  document.getElementById("title").value = traveller.travellerTitle || "";
  document.getElementById("firstName").value = traveller.travellerFirstName || "";
  document.getElementById("middleName").value = traveller.travellerMiddleName || "";
  document.getElementById("lastName").value = traveller.travellerLastName || "";
  document.getElementById("email").value = traveller.travellerEmail || "";
  document.getElementById("mobile").value = traveller.travellerMobile || "";
  document.getElementById("passportNumber").value = traveller.passportNumber || "";
  document.getElementById("dob").value = traveller.travellerDob || "";
  document.getElementById("gender").value = traveller.gender || "";
  document.getElementById("occupation").value = traveller.occupation || "";
  document.getElementById("passportExpiry").value = traveller.passportExpiry || "";

  // Show personal details section
  const personalDetailsSection = document.getElementById("personalDetailsSection");
  if (personalDetailsSection) {
    personalDetailsSection.style.display = "block";
    personalDetailsSection.querySelectorAll(".form-grid").forEach(grid => grid.style.display = "grid");
    personalDetailsSection.querySelectorAll("h3").forEach(h3 => h3.style.display = "block");
  }

  // Hide saved travellers section
  const section = document.getElementById("savedTravellersSection");
  if (section) section.classList.add("hidden");

  // Move to next step
  showStep(currentStep + 1);
  update();
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function resetPassportUpload(element, originalText, originalSubtitle) {
  if (element) {
    const uploadText = element.querySelector(".upload-text");
    const uploadSubtitle = element.querySelector(".upload-subtitle");

    if (uploadText) uploadText.textContent = originalText;
    if (uploadSubtitle) uploadSubtitle.textContent = originalSubtitle;

    element.style.borderColor = "#cbd5e1";
    element.style.backgroundColor = "#f8fafc";
    element.classList.remove("uploaded");
  }
}


function handleUpload(uploadElement, title, key, acceptTypes = ".pdf,.jpg,.jpeg,.png") {
  if (!uploadElement || uploadElement.dataset.listenerAdded) return;

       uploadElement.dataset.listenerAdded = "true";

       const fileInput = uploadElement.querySelector('input[type="file"]');
       if (!fileInput) return;
       
      // File selected → update UI
      fileInput.addEventListener("change", (e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      uploadedFiles[key] = file;

     // Cached selectors
      const uploadText = uploadElement.querySelector(".upload-text");
      const uploadSubtitle = uploadElement.querySelector(".upload-subtitle");
 
      uploadText.textContent = `Uploaded: ${file.name}`;
      uploadSubtitle.textContent = "File uploaded successfully!";

     // Add uploaded state
     uploadElement.classList.add("uploaded");

      // Trigger your global validation
     checkAllUploadsAndTriggerAPI();
  });
}

function checkAllUploadsAndTriggerAPI() {
  const passportFrontUpload = document.getElementById("passportFrontUpload");
  const passportBackUpload = document.getElementById("passportBackUpload");
  const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");
  const personalDetailsSection = document.getElementById("personalDetailsSection");

  const frontUploaded = passportFrontUpload.classList.contains("uploaded");
  const backUploaded = passportBackUpload.classList.contains("uploaded");
  const photoUploaded = travelerPhotoUpload.classList.contains("uploaded");

  if (frontUploaded && backUploaded && photoUploaded && personalDetailsSection) {
    personalDetailsSection.style.display = "block";
    fetchPassportDataFromAPI();
  }
}


const generateTravellerId = () => {
  const timestamp = Date.now();
  const randomNum = Math.floor(Math.random() * 10000);
  return `${timestamp}${randomNum}`;
};

function proceedToPayment() {
  // LOGIN CHECK
  if (!userLoggedIn) {
    showAuthModal("login");
    window.pendingProceedToPayment = true;
    return;
  }
  console.log("Normal mode → saving traveller");
  saveTravellerData();
}

function saveTravellerData() {
  // --- SHOW LOADING OVERLAY ---
   const loadingOverlay = document.createElement("div");
   loadingOverlay.id = "paymentLoadingOverlay";
   loadingOverlay.style.cssText = `
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.45); display: flex; align-items: center;
  justify-content: center; z-index: 9999; backdrop-filter: blur(3px);
  `;

  loadingOverlay.innerHTML = `
  <div style="
    background: #ffffff;
    padding: 2.5rem 2rem;
    border-radius: 16px;
    text-align: center;
    max-width: 420px;
    height: 200px;
    width: 90%;
    border: 3px solid #22c55e;
    box-shadow: 0 0 20px rgba(34,197,94,0.35);
    font-family: 'Inter', sans-serif;
  ">

    <!-- SPINNER -->
    <div class="green-spinner" style="
      width: 55px;
      height: 55px;
      border: 6px solid #d1fae5;
      border-top-color: #22c55e;
      border-radius: 50%;
      animation: spin 0.9s linear infinite;
      margin: 0 auto 1.2rem auto;
    "></div>

    <h3 style="
      margin-bottom: 0.5rem;
      font-size: 1.4rem;
      color: #0f172a;
      font-weight: 600;
    ">Saving Traveller Details</h3>

    <p style="color: #475569; font-size: 1rem;">
      Please wait a moment...
    </p>
  </div>

  <style>
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  </style>
  `;

  document.body.appendChild(loadingOverlay);

  // --- CUSTOMER EMAIL ---
  const customerEmail = currentUser?.email || "";

  // --- COLLECT TEXT FIELDS ---
  const textFields = {
    travellerId: currentEditingIndex >= 0 
    ? window.travellers[currentEditingIndex].travellerId
    : generateTravellerId(),

    travellerTitle: document.getElementById("title")?.value || "",
    travellerFirstName: document.getElementById("firstName")?.value || "",
    travellerMiddleName: document.getElementById("middleName")?.value || "",
    travellerLastName: document.getElementById("lastName")?.value || "",
    travellerEmail: document.getElementById("email")?.value || "",
    travellerMobile: document.getElementById("mobile")?.value || "",
    passportNumber: document.getElementById("passportNumber")?.value || "",
    travellerDob: document.getElementById("dob")?.value || "",
    gender: document.getElementById("gender")?.value || "",
    occupation: document.getElementById("occupation")?.value || "",
    passportExpiry: document.getElementById("passportExpiry")?.value || "",
    travelStartDate: document.getElementById("travelStartDate")?.value || "",
    travelEndDate: document.getElementById("travelEndDate")?.value || "",
    customerEmail: customerEmail,
    variantId: selectedData["variantId"],
    visaFee: selectedData["visaFee"],
    govtFee: selectedData["govtFee"],
    serviceTax: selectedData["serviceTax"],
    matrixGovtFee: selectedData["matrixGovtFee"],
    matrixFee: selectedData["matrixFee"],
    price: selectedData["price"]
  };

  // --- API SIGNING ---
  const bodyText = canonicalJSONString(textFields);
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.SAVE_TRAVELLER_ENDPOINT;

  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;
  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(CryptoJS.enc.Hex);

  // --- BUILD FORMDATA ---
  let formData = new FormData();
  Object.keys(textFields).forEach((key) => formData.append(key, textFields[key]));

  // Attach uploaded files (only if exist)
  if (uploadedFiles.passportFront) formData.append("passportFront", uploadedFiles.passportFront);
  if (uploadedFiles.passportBack) formData.append("passportBack", uploadedFiles.passportBack);
  if (uploadedFiles.travellerImage) formData.append("travellerImage", uploadedFiles.travellerImage);

  // Travel docs
  const flightFile = document.getElementById("flightFile")?.files?.[0];
  const hotelFile = document.getElementById("hotelFile")?.files?.[0];
  const bankFile = document.getElementById("bankFile")?.files?.[0];

  if (flightFile) formData.append("flightTicket", flightFile);
  if (hotelFile) formData.append("hotelBooking", hotelFile);
  if (bankFile) formData.append("bankStatement", bankFile);

  formData.append("hash_data", hashData);

  // --- AJAX CALL ---
  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },

    success: function (resp) {
      document.getElementById("paymentLoadingOverlay")?.remove();
      // Build traveller object 
      const travellerData = {
        ...textFields,
        applicationId: resp.applicationId || textFields.travellerId,

        hasPassportFront: !!uploadedFiles.passportFront,
        hasPassportBack: !!uploadedFiles.passportBack,
        hasTravellerImage: !!uploadedFiles.travellerImage,

        hasFlightTicket: !!flightFile,
        hasHotelBooking: !!hotelFile,
        hasBankStatement: !!bankFile,
      };

      if (currentEditingIndex >= 0) {
        window.travellers[currentEditingIndex] = travellerData;
      } else {
        window.travellers.push(travellerData);
      }
      
      currentEditingIndex = -1;
      saveProgress();
      clearFormData();
      showStep(1);
      update();

      showSuccessMessage();
      updateOngoingApplicationCard();
    },

    error: function (xhr) {
      document.getElementById("paymentLoadingOverlay")?.remove();
      alert("Error saving application:\n\n" + (xhr.responseText || "Please try again."));
    }
  });
}

function displaySidebarTravellers() {
  const sidebarList = document.getElementById("sidebarTravellersList");
  if (!sidebarList) return;
  console.log(window.travellers)
  if (!window.travellers || window.travellers.length === 0) {
    sidebarList.innerHTML =
      '<p style="text-align: center; color: #64748b; padding: 1rem; font-size: 0.85rem;">No travellers added yet</p>';
    return;
  }

  sidebarList.innerHTML = window.travellers
    .map(
      (traveller, index) => `
    <div class="sidebar-traveller-item">
      <div class="sidebar-traveller-main">
        <div class="sidebar-traveller-number">${index + 1}</div>
        <div class="sidebar-traveller-info">
          <div class="sidebar-traveller-name">${traveller.travellerTitle}. ${traveller.travellerFirstName} ${
        traveller.travellerLastName
      }</div>
          <div class="sidebar-traveller-passport">${
            traveller.passportNumber
          }</div>
        </div>
      </div>
      <div class="sidebar-traveller-actions">
        <button class="sidebar-btn-edit" onclick="editTraveller(${index})" title="Edit">✏️</button>
        <button class="sidebar-btn-delete" onclick="deleteTraveller(${index})" title="Delete">🗑️</button>
      </div>
    </div>
  `
    )
    .join("");
  // Force display
  sidebarList.style.display = "block";
}

function updateOngoingApplicationCard() {
  const savedProgressCard = document.getElementById("savedProgressCard");
  const progressDateEl = document.getElementById("progressDate");
  const progressStepEl = document.getElementById("progressStep");
  const progressTravellersEl = document.getElementById("progressTravellers");
  const btnProceedPayment = document.getElementById("btnProceedPayment");
  const btnResume = document.getElementById("btnResume");

  if (savedProgressCard && window.travellers.length > 0) {
    savedProgressCard.classList.remove("hidden");

    if (progressDateEl) {
      progressDateEl.textContent = `Last saved: ${new Date().toLocaleDateString()}`;
    }

    if (progressStepEl) {
      progressStepEl.textContent = `Step: Ready for more travellers`;
    }

    if (progressTravellersEl) {
      progressTravellersEl.textContent = `Travellers: ${window.travellers.length}`;
    }

    // Show appropriate buttons
    if (btnProceedPayment) btnProceedPayment.style.display = "none";
    if (btnResume) btnResume.style.display = "none";

    // Display travellers in sidebar
    setTimeout(() => {
      displaySidebarTravellers();
    }, 50);
  }
}
function showSuccessMessage() {
  const overlay = document.getElementById("successMessageOverlay");
  const countEl = document.getElementById("successTravellerCount");
  const amountEl = document.getElementById("successTotalAmount");

  if (overlay) {
    // Update count and amount
    if (countEl) countEl.textContent = window.travellers.length;
    if (amountEl) {
      const total = window.travellers.reduce((sum, item) => sum + (item.price || 0), 0);
      amountEl.textContent = total.toLocaleString();
    }

    // Show overlay
    overlay.classList.remove("hidden");
    setTimeout(() => {
      overlay.classList.add("active");
    }, 10);
  }
}
function hideSuccessMessage() {
  const overlay = document.getElementById("successMessageOverlay");
  if (overlay) {
    overlay.classList.remove("active");
    setTimeout(() => {
      overlay.classList.add("hidden");
    }, 300);
  }
}

function addNewTraveller() {
  currentEditingIndex = -1;
  // Reset edit mode flags
  window.isEditMode = false;
  window.editingTravellerIndex = null;
  window.editingTravellerData = null;
  clearFormData();

  // Hide success message
  hideSuccessMessage();

  // Keep ongoing card visible - update it to show current travellers
  if (travellers.length > 0) {
    const savedProgressCard = document.getElementById("savedProgressCard");
    if (savedProgressCard) {
      savedProgressCard.classList.remove("hidden");
    }
    updateOngoingApplicationCard();
  }

  showStep(1);
  update();
  window.scrollTo({ top: 0, behavior: "smooth" });
}


function editTraveller(index) {
   window.isEditMode = true;
   console.log("Index --",index);
  // Reset NEXT button to remove all old listeners before Edit Mode starts
   const nextBtn = document.querySelector(".next-btn");
   replaceButtonWithClone(nextBtn); 

  if (index < 0 || index >= window.travellers.length) return;

  window.currentEditingIndex = index;
  const traveller = window.travellers[index];
 
  // Keep saved progress visiblse
  const savedProgressCard = document.getElementById("savedProgressCard");
  if (savedProgressCard) {
    savedProgressCard.classList.remove("hidden");
  }
  console.log("Traveller variant id ", traveller.variantId);
  // Fill personal details
  document.getElementById("title").value = traveller.travellerTitle;
  document.getElementById("firstName").value = traveller.travellerFirstName;
  document.getElementById("middleName").value = traveller.travellerMiddleName || "";
  document.getElementById("lastName").value = traveller.travellerLastName;
  document.getElementById("email").value = traveller.travellerEmail;
  document.getElementById("mobile").value = traveller.travellerMobile;
  document.getElementById("passportNumber").value = traveller.passportNumber;
  document.getElementById("dob").value = traveller.travellerDob;
  document.getElementById("gender").value = traveller.gender || "";
  document.getElementById("occupation").value = traveller.occupation || "";
  document.getElementById("passportExpiry").value = traveller.passportExpiry || "";

  
  if (traveller.travelStartDate) {
    document.getElementById("travelStartDate").value = traveller.travelStartDate;
  }

  if (traveller.travelEndDate) {
    document.getElementById("travelEndDate").value = traveller.travelEndDate;
  }

  // Restore uploaded file states
  if (traveller.hasPassportFront) {
    markAsUploaded("passportFrontUpload", "Passport front (saved)");
  }
  if (traveller.hasPassportBack) {
    markAsUploaded("passportBackUpload", "Passport back (saved)");
  }
  if (traveller.hasTravellerImage) {
    markAsUploaded("travelerPhotoUpload", "Photo (saved)");
  }

  // Show Personal Details section
  const personalDetailsSection = document.getElementById("personalDetailsSection");
  if (personalDetailsSection) {
    personalDetailsSection.style.display = "block";
    const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
    const headings = personalDetailsSection.querySelectorAll("h3");
    formGrids.forEach((grid) => (grid.style.display = "grid"));
    headings.forEach((heading) => (heading.style.display = "block"));
  }

  // Move user to Step 1 form
  showStep(1);
  update();
 
 const observer = new MutationObserver(() => {
  const card = document.querySelector(`[data-selected-variant='${traveller.variantId}']`);
  
  if (card) {
    $(".visa-card-active").removeClass("visa-card-active");
    card.classList.add("visa-card-active");
    observer.disconnect(); // stop listening
  }
});

// Observe the container where visa cards appear
observer.observe(document.body, {
  childList: true,
  subtree: true
});

  // Scroll to top
  window.scrollTo({ top: 0, behavior: "smooth" });
}


function deleteTraveller(index) {
  if (!Array.isArray(window.travellers)) window.travellers = [];
  if (index < 0 || index >= window.travellers.length) return;

  const traveller = window.travellers[index];

  const confirmed = confirm(
    `Are you sure you want to delete traveller:\n${traveller.travellerFirstName} ${traveller.travellerLastName}?`
  );

  if (!confirmed) return;

  // DELETE traveller
  window.travellers.splice(index, 1);

  // ------------------------------
  // Update UI (Ongoing Card)
  // ------------------------------
  if (window.travellers.length > 0) {
    updateOngoingApplicationCard();
  } else {
    // No travellers left → hide saved card
    const savedProgressCard = document.getElementById("savedProgressCard");
    if (savedProgressCard) savedProgressCard.classList.add("hidden");
  }

  saveProgress();

  alert("Traveller deleted successfully!");
}


function clearFormData() {
  
  // Clear all form inputs
  document.getElementById("title").value = "";
  document.getElementById("firstName").value = "";
  document.getElementById("middleName").value = "";
  document.getElementById("lastName").value = "";
  document.getElementById("gender").value = "";
  document.getElementById("dob").value = "";
  document.getElementById("occupation").value = "";
  document.getElementById("mobile").value = "";
  document.getElementById("email").value = "";
  document.getElementById("passportNumber").value = "";
  document.getElementById("passportExpiry").value = "";
  document.getElementById("travelStartDate").value = "";
  document.getElementById("travelEndDate").value = "";
   //Clearing number of days
   document
  .querySelectorAll('#purposeOfVisitSection .right input[type="radio"]')
  .forEach(radio => radio.checked = false);
   document.querySelectorAll(".photo-preview img").forEach(img => {
  if (img.src.startsWith("blob:") || img.src.startsWith("data:")) {
    img.src = img.dataset.placeholder;
  }
    });

  document.querySelectorAll('.photo-upload input[type="file"]').forEach(input => {
  input.value = "";  
   });
  
  document.querySelectorAll("#visaTypeSection .visa-card").forEach(card=> card.classList.remove("visa-card-active"))
  // Clear file inputs
  const flightFile = document.getElementById("flightFile");
  const hotelFile = document.getElementById("hotelFile");
  const bankFile = document.getElementById("bankFile");

  if (flightFile) flightFile.value = "";
  if (hotelFile) hotelFile.value = "";
  if (bankFile) bankFile.value = "";

  // Clear uploaded files
  uploadedFiles = {
    passportFront: null,
    passportBack: null,
    travellerImage: null,
  };

  // Reset upload UI states
  resetPassportUpload(
    document.getElementById("passportFrontUpload"),
    "Upload Passport Front",
    "Upload the front page of your passport"
  );
  resetPassportUpload(
    document.getElementById("passportBackUpload"),
    "Upload Passport Back",
    "Upload the back page of your passport"
  );
  resetPassportUpload(
    document.getElementById("travelerPhotoUpload"),
    "Upload Photo",
    "Passport size photo (optional)"
  );



  // Hide personal details section
  const personalDetailsSection = document.getElementById(
    "personalDetailsSection"
  );
  if (personalDetailsSection) {
    personalDetailsSection.style.display = "none";
  }


  const passportUploads = document.getElementById("passportUploads");
  if (passportUploads) {
    passportUploads.classList.remove("disabled");
  }

 
  const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");
  if (travelerPhotoUpload) {
    travelerPhotoUpload.classList.remove("disabled");
    travelerPhotoUpload.style.opacity = "1";
    travelerPhotoUpload.style.pointerEvents = "auto";
  }

  // Clear errors
  clearAuthErrors();

  // Reset API call flag
  window.passportDataFetched = false;
}



// Auth Modal Management
function showAuthModal(formType = "login") {
  const modal = document.getElementById("authModal");
  const modalTitle = document.getElementById("modalTitle");
  const loginForm = document.getElementById("loginForm");
  const signupForm = document.getElementById("signupForm");
  const otpForm = document.getElementById("otpForm");

  // Hide all forms first
  loginForm.classList.add("hidden");
  signupForm.classList.add("hidden");
  otpForm.classList.add("hidden");

  // Show the requested form
  if (formType === "login") {
    loginForm.classList.remove("hidden");
    modalTitle.textContent = "Login";
  } else if (formType === "signup") {
    signupForm.classList.remove("hidden");
    modalTitle.textContent = "Sign Up";
  } else if (formType === "otp") {
    otpForm.classList.remove("hidden");
    modalTitle.textContent = "Verify OTP";
  }

  modal.classList.add("active");
  document.body.style.overflow = "hidden";
}

function hideAuthModal() {
  const modal = document.getElementById("authModal");
  modal.classList.remove("active");
  document.body.style.overflow = "auto";

  // Clear all forms
  clearAuthForms();
}

function clearAuthForms() {
  // Clear login form
  document.getElementById("loginEmail").value = "";
  document.getElementById("loginPassword").value = "";
  clearAuthErrors();

  // Clear signup form
  document.getElementById("signupFirstName").value = "";
  document.getElementById("signupLastName").value = "";
  document.getElementById("signupEmail").value = "";
  document.getElementById("signupMobile").value = "";
  document.getElementById("signupPassword").value = "";
  document.getElementById("signupConfirmPassword").value = "";

  // Clear OTP form
  document.querySelectorAll(".otp-digit").forEach((input) => {
    input.value = "";
    input.classList.remove("filled", "error");
  });
}

function clearAuthErrors() {
  document.querySelectorAll(".error-message").forEach((error) => {
    error.textContent = "";
  });
  document.querySelectorAll(".error").forEach((field) => {
    field.classList.remove("error");
  });
}

// Validation Functions for Auth
function validateAuthField(fieldId, validationFn, errorMessage) {
  const field = document.getElementById(fieldId);
  const errorDiv = document.getElementById(fieldId + "Error");

  if (!field) return true;

  const isValid = validationFn(field.value);

  if (!isValid) {
    field.classList.add("error");
    if (errorDiv) errorDiv.textContent = errorMessage;
    return false;
  } else {
    field.classList.remove("error");
    if (errorDiv) errorDiv.textContent = "";
    return true;
  }
}

function validatePassword(value) {
  // Password should be at least 8 characters with at least one number and one letter
  return value.length >= 8 && /[0-9]/.test(value) && /[a-zA-Z]/.test(value);
}

function validateConfirmPassword(password, confirmPassword) {
  return password === confirmPassword && password.length > 0;
}

// Login Validation
function validateLoginForm() {
  let isValid = true;

  isValid &= validateAuthField(
    "loginEmail",
    validateEmail,
    "Please enter a valid email address"
  );
  isValid &= validateAuthField(
    "loginPassword",
    (v) => v.length > 0,
    "Password is required"
  );

  return isValid;
}

// Signup Validation
function validateSignupForm() {
  let isValid = true;

  isValid &= validateAuthField(
    "signupFirstName",
    (v) => v.trim().length > 0,
    "First name is required"
  );
  isValid &= validateAuthField(
    "signupLastName",
    (v) => v.trim().length > 0,
    "Last name is required"
  );
  isValid &= validateAuthField(
    "signupEmail",
    validateEmail,
    "Please enter a valid email address"
  );
  isValid &= validateAuthField(
    "signupPassword",
    validatePassword,
    "Password must be at least 8 characters with numbers and letters"
  );

  // Confirm password validation
  const password = document.getElementById("signupPassword").value;
  const confirmPassword = document.getElementById(
    "signupConfirmPassword"
  ).value;
  isValid &= validateAuthField(
    "signupConfirmPassword",
    (v) => validateConfirmPassword(password, v),
    "Passwords do not match"
  );

  return isValid;
}

// OTP Input Handling
function setupOTPInputs() {
  const otpInputs = document.querySelectorAll(".otp-digit");

  otpInputs.forEach((input, index) => {
    input.addEventListener("input", (e) => {
      const value = e.target.value;

      if (!/^\d$/.test(value)) {
        e.target.value = "";
        return;
      }

      e.target.classList.add("filled");

      // Move to next input
      if (value && index < otpInputs.length - 1) {
        otpInputs[index + 1].focus();
      }
    });

    input.addEventListener("keydown", (e) => {
      // Handle backspace
      if (e.key === "Backspace" && !input.value && index > 0) {
        otpInputs[index - 1].focus();
      }

      // Handle paste
      if (e.key === "Delete") {
        input.value = "";
        input.classList.remove("filled");
      }
    });

    // Handle paste
    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const paste = e.clipboardData.getData("text");
      const digits = paste.replace(/\D/g, "").split("");

      digits.forEach((digit, i) => {
        if (index + i < otpInputs.length) {
          otpInputs[index + i].value = digit;
          otpInputs[index + i].classList.add("filled");
        }
      });

      // Focus the next empty input or last input
      const nextIndex = Math.min(index + digits.length, otpInputs.length - 1);
      otpInputs[nextIndex].focus();
    });
  });
}

function getOTPValue() {
  const otpInputs = document.querySelectorAll(".otp-digit");
  return Array.from(otpInputs)
    .map((input) => input.value)
    .join("");
}

function setOTPError(message) {
  const errorDiv = document.getElementById("otpError");
  const otpInputs = document.querySelectorAll(".otp-digit");

  errorDiv.textContent = message;
  otpInputs.forEach((input) => {
    input.classList.add("error");
  });
}

function clearOTPError() {
  const errorDiv = document.getElementById("otpError");
  const otpInputs = document.querySelectorAll(".otp-digit");

  errorDiv.textContent = "";
  otpInputs.forEach((input) => {
    input.classList.remove("error");
  });
}

// Simulate API Calls (Replace with actual API calls)
function simulateLogin(email, password) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Simulate API response
      if (email.toLowerCase() === "deepakpant@matrix.in" && password === "Deepak123") {
        resolve({ success: true, user: { email, name: "Deepak Pant" } });
        $('#loginBtn').html('<span class="login-icon">👤</span> Deepak Pant');
        $('#loginBtn').attr('disabled', 'disabled');
        // fetchSavedTravellers();
      } else {
        reject({ message: "Invalid email or password" });
      }
    }, 1500);
  });
}

function simulateSignup(userData) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Simulate API response
      const existingEmails = ["existing@example.com"];
      if (existingEmails.includes(userData.email)) {
        reject({ message: "Email already exists" });
      } else {
        resolve({ success: true, message: "OTP sent successfully" });
      }
    }, 1500);
  });
}

function simulateOTPVerification(otp) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Simulate API response
      if (otp === "123456") {
        resolve({ success: true, message: "Account created successfully" });
      } else {
        reject({ message: "Invalid OTP. Please try again." });
      }
    }, 1000);
  });
}

// Event Listeners Setup
function setupAuthEventListeners() {
  // Login button
  document.getElementById("loginBtn").addEventListener("click", () => {
    showAuthModal("signup");
  });

  // Close modal
  document
    .getElementById("closeModal")
    .addEventListener("click", hideAuthModal);

  // Close modal on overlay click
  // document.getElementById("authModal").addEventListener("click", (e) => {
  //   if (e.target.id === "authModal") {
  //     hideAuthModal();
  //   }
  // });

  // Switch between forms
  document.getElementById("switchToSignup").addEventListener("click", (e) => {
    e.preventDefault();
    showAuthModal("signup");
  });

  document.getElementById("switchToLogin").addEventListener("click", (e) => {
    e.preventDefault();
    showAuthModal("login");
  });

  // In simulateLogin success:
  async function handleLoginSuccess(userEmail) {
    userLoggedIn = true;
    currentUser = { email: userEmail };
    console.log("User logged in with email:", userEmail);
    console.log("currentUser object:", currentUser);
    // If there was a pending proceed action
    hideAuthModal();

    if (window.pendingProceedToPayment) {
      window.pendingProceedToPayment = false;
      saveTravellerData();
    } else {
      alert("Login successful! Welcome back.");
      // Fetch saved travellers after login
      await fetchSavedTravellers();
    }
  }

  // Signup Form Submit
  document.getElementById("signupForm").addEventListener("submit", async (e) => {
    e.preventDefault();

    if (!validateSignupForm()) return;

    const submitBtn = e.target.querySelector(".auth-btn");
    submitBtn.classList.add("loading");
    submitBtn.disabled = true;

    const payload = {
      firstName: signupFirstName.value.trim(),
      lastName: signupLastName.value.trim(),
      email: signupEmail.value.trim(),
      password: signupPassword.value,
    };

    try {
      const response = await sendOtpAPI(payload);

      if (!response.success) {
        if (response.reason === "exists") {
          signupEmailError.textContent = "Account already exists with this email.";
          return;
        }
        signupEmailError.textContent = response.message || "Unable to send OTP.";
        return;
      }

      // OTP sent → show OTP modal
      showAuthModal("otp");

    } catch (err) {
      signupEmailError.textContent = err.message || "OTP send failed.";
    } finally {
      submitBtn.classList.remove("loading");
      submitBtn.disabled = false;
    }
  });

  document.getElementById("otpForm").addEventListener("submit", async (e) => {
    e.preventDefault();

    const otp = [...document.querySelectorAll(".otp-digit")]
      .map(i => i.value)
      .join("");

    if (otp.length !== 6) {
      setOTPError("Please enter all 6 digits");
      return;
    }

    const submitBtn = e.target.querySelector(".auth-btn");
    submitBtn.classList.add("loading");
    submitBtn.disabled = true;

    try {
      // 🚀 Secure verify-otp API call
      const verify = await verifyOtpAPI({ otp });

      if (!verify.success) {
        setOTPError(verify.message || "Invalid OTP");
        return;
      }

      // OTP Verified → Create Shopify Account
      shopifySignupFirstName.value = signupFirstName.value;
      shopifySignupLastName.value = signupLastName.value;
      shopifySignupEmail.value = signupEmail.value;
      shopifySignupPassword.value = signupPassword.value;

      initShopifyCaptcha();

      setTimeout(() => {
        document.getElementById("shopifySignupForm").submit();
      }, 300);

    } catch (err) {
      setOTPError(err.message || "Server error");
    } finally {
      submitBtn.classList.remove("loading");
      submitBtn.disabled = false;
    }
  });

  async function verifyOtpAPI(otpPayload) {
    return new Promise((resolve, reject) => {
      if (!otpPayload.otp) {
        reject({ message: "OTP is required" });
        return;
      }

      // canonical JSON
      const bodyText = canonicalJSONString(otpPayload);

      // timestamp
      const timestamp = Math.floor(Date.now() / 1000);

      // endpoint
      const apiEndPoint = API_CONFIG.VERIFY_OTP; 
      const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

      console.log("VERIFY OTP - Signing message:", message);

      // HMAC
      const hashData = CryptoJS.HmacSHA256(
        message,
        API_CONFIG.SECRET
      ).toString(CryptoJS.enc.Hex);

      console.log("VERIFY OTP - hash:", hashData);

      // Build form data
      let formData = new FormData();
      for (let k in otpPayload) {
        formData.append(k, otpPayload[k]);
      }
      formData.append("hash_data", hashData);

      // AJAX
      $.ajax({
        url: `${API_CONFIG.API_URL}${apiEndPoint}`,
        type: "POST",
        headers: {
          "X-API-Key": API_CONFIG.API_KEY,
          "X-Auth-Token": timestamp,
        },
        data: formData,
        processData: false,
        contentType: false,
        xhrFields: { withCredentials: true },

        success: (resp) => {
          console.log("VERIFY OTP Success:", resp);
          resolve(resp);
        },
        error: (xhr) => {
          console.error("VERIFY OTP Error:", xhr.responseText);
          try {
            reject(JSON.parse(xhr.responseText));
          } catch (e) {
            reject({ message: xhr.responseText });
          }
        },
      });
    });
  }


  // In simulateOTPVerification success (after signup):
  async function handleSignupSuccess(userEmail) {
    userLoggedIn = true;
    currentUser = { email: userEmail };
    console.log("User signed up with email:", userEmail);
    console.log("currentUser object:", currentUser);

    hideAuthModal();

    if (window.pendingProceedToPayment) {
      window.pendingProceedToPayment = false;
      saveTravellerData();
    } else {
      alert("Account created successfully!");
      // Fetch saved travellers after signup (probably empty for new users)
      await fetchSavedTravellers();
    }
  }

  // Resend OTP using the SEND_OTP API
  document.getElementById("resendOtp").addEventListener("click", async (e) => {
    e.preventDefault();

    const email = signupEmail.value.trim();
    if (!email) return;

    // Reset UI
    document.querySelectorAll(".otp-digit").forEach((i) => {
      i.value = "";
      i.classList.remove("filled", "error");
    });
    clearOTPError();

    try {
      const response = await sendOtpAPI({ email });

      if (response.success) {
        showTempMessage("OTP resent successfully!");
      } else {
        showTempMessage(response.message || "Failed to resend OTP");
      }

    } catch (err) {
      showTempMessage(err.message || "Server error");
    }

    document.querySelector(".otp-digit").focus();
  });

  // Setup OTP inputs
  setupOTPInputs();
}

async function sendOtpAPI(payload) {
  return new Promise((resolve, reject) => {
    // Ensure email at minimum
    if (!payload.email) {
      reject({ message: "Email is required" });
      return;
    }

    // Canonical JSON string (same as deleteTraveller)
    const bodyText = canonicalJSONString(payload);

    // Timestamp
    const timestamp = Math.floor(Date.now() / 1000);

    // API endpoint
    const apiEndPoint = API_CONFIG.SEND_OTP;
    const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

    console.log("SEND OTP - Signing message:", message);

    // HMAC Hash
    const hashData = CryptoJS.HmacSHA256(
      message,
      API_CONFIG.SECRET
    ).toString(CryptoJS.enc.Hex);

    console.log("SEND OTP - hash_data:", hashData);

    // Create FormData
    let formData = new FormData();
    for (let key in payload) {
      formData.append(key, payload[key]);
    }
    formData.append("hash_data", hashData);

    // AJAX Call
    $.ajax({
      url: `${API_CONFIG.API_URL}${apiEndPoint}`,
      type: "POST",
      headers: {
        "X-API-Key": API_CONFIG.API_KEY,
        "X-Auth-Token": timestamp,
      },
      data: formData,
      processData: false,
      contentType: false,
      xhrFields: { withCredentials: true },

      success: (resp) => {
        console.log("SEND OTP Success:", resp);
        resolve(resp);
      },
      error: (xhr) => {
        console.error("SEND OTP Error:", xhr.responseText);
        try {
          reject(JSON.parse(xhr.responseText));
        } catch (e) {
          reject({ message: xhr.responseText });
        }
      },
    });
  });
}


function showTempMessage(msg) {
  const el = document.createElement("div");
  el.className = "temp-toast";
  el.textContent = msg;

  document.body.appendChild(el);

  setTimeout(() => {
    el.classList.add("show");
  }, 10);

  setTimeout(() => {
    el.classList.remove("show");
    setTimeout(() => el.remove(), 300);
  }, 2500);
}


function proceedToFinalPayment() {
  if (travellers.length === 0) {
    alert("Please add at least one traveller before proceeding to payment.");
    return;
  }

  // Hide success message
  hideSuccessMessage();

  // Calculate total amount
  const totalAmount = traveller.reduce((sum, item) => sum + (item.price || 0), 0);

  const confirmed = confirm(
    `Total Amount: ₹${totalAmount.toLocaleString()}\n\nTravellers: ${
      travellers.length
    }\n\nProceed to payment?`
  );

  if (confirmed) {
    // Clear saved progress as application is being completed
    clearSavedProgress();

    // Here you would redirect to payment gateway or show payment screen
    alert(
      `Proceeding to payment gateway...\n\nTotal: ₹${totalAmount.toLocaleString()}\nTravellers: ${
        travellers.length
      }\n\n(Payment integration pending)`
    );

    // Example: Redirect to payment URL with all traveller IDs
    const travellerIds = travellers.map((t) => t.applicationId).join(",");
    // window.location.href = `/payment?amount=${totalAmount}&travellers=${travellers.length}&ids=${travellerIds}`;
  }
}

// Add to Cart function
async function addToCart() {
  const payload = {
    items: []
  };
  for (const traveller of window.travellers) {
    try {
      const properties = {
        "_travellerId": traveller.travellerId,
        "_travellerFirstName": traveller.travellerFirstName,
        "_travellerMiddleName": traveller.travellerMiddleName,
        "_travellerLastName": traveller.travellerLastName,
        "_travellerEmail": traveller.travellerEmail,
        "_travellerMobile": traveller.travellerMobile,
        "_passportNumber": traveller.passportNumber,
        "_dob": traveller.travellerDob,
        "_gender": traveller.gender,
        "_occupation": traveller.occupation,
        "_passportExpiry": traveller.passportExpiry,
        "_travelStartDate": traveller.travelStartDate,
        "_travelEndDate": traveller.travelEndDate,
        "_customerEmail": traveller.customerEmail,
        "_applicationId": traveller.applicationId,
        "_travellerTitle": traveller.travellerTitle
      };
      payload['items'].push({
        id: traveller.variantId,
        quantity: 1,
        properties: properties
      })

    } catch (error) {
      console.error(`⚠️ Error adding traveller ${traveller.travellerId}`, error);
    }
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const err = await response.json();
    console.error(`❌ Failed to add to cart`, err);
    console.log("Some error occured, Please try later")
  } else {
    const data = await response.json();
    console.log(`✅ Added traveller`, data);
    window.location.href = '/cart';
  }
  // ✅ After all travellers added, redirect to cart page
  
}

function initValidationListeners() {
    const fields = [
        { id: "title", validator: validateName, message: "Please select title" },
        { id: "occupation", validator: validateName, message: "Please select occupation" },
        { id: "firstName", validator: validateName, message: "Invalid first name" },
        { id: "lastName", validator: validateName, message: "Invalid last name" },
        { id: "mobile", validator: validateMobile, message: "Invalid mobile number" },
        { id: "email", validator: validateEmail, message: "Invalid email" },
        { id: "dob", validator: validateDateOfBirth, message: "Invalid date of birth" },
        { id: "passportNumber", validator: validatePassportNumber, message: "Invalid passport number" },
        { id: "passportExpiry", validator: validatePassportExpiry, message: "Passport should be valid 6 months" },
        { id: "travelStartDate", validator: validateTravelStartDate, message: "Invalid start date" },
        { id: "travelEndDate", validator: validateTravelEndDate, message: "Invalid end date" },
    ];

    fields.forEach(f => {
        const el = document.getElementById(f.id);
        if (el) {
            el.addEventListener("blur", () => {
                validateField(f.id, f.validator, f.message);
            });
        }
    });
}

function initUploadHandlers() {
    const travelerPhoto = document.getElementById("travelerPhotoUpload");
    const passportFront = document.getElementById("passportFrontUpload");
    const passportBack = document.getElementById("passportBackUpload");

    if (travelerPhoto) handleUpload(travelerPhoto, "Traveler Photo", "travellerImage");
    if (passportFront) handleUpload(passportFront, "Passport Front", "passportFront");
    if (passportBack) handleUpload(passportBack, "Passport Back", "passportBack");
}


document.addEventListener("DOMContentLoaded", function () {

    console.log("DOM Ready");
    const savedProgress = loadProgress();

    if (savedProgress) {
      window.isRestoring = true;
      restoreProgress(savedProgress);
      updateTravelDays();
      filterCard(savedProgress?.formData?.dob);

        setTimeout(() => {
            showProgressPrompt(savedProgress);
        }, 300);
        window.isRestoring = false;  
        window.restoreCompleted = true;
     }

    // 2. Initialize validation listeners
    initValidationListeners();

    // 3. Initialize previous button
    const prevBtn = document.querySelector(".prev-btn");
    if (prevBtn) {
        prevBtn.addEventListener("click", function () {
            if (currentStep > 1) {
                showStep(currentStep - 1);
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        });
    }

    // 4. Initialize upload handlers
    initUploadHandlers();

    // 5. If NO restore happened, show Step 1
    setTimeout(() => {
        if (!window.restoreCompleted) {
            console.log("No restore found → starting at Step 1");
            showStep(1);
        }
    }, 100);

});



// add active css to clicked visa card when clicked
$(document).on('click', '.visa-card', function() {
  $('.visa-card').removeClass('visa-card-active');
  $(this).addClass('visa-card-active');
  // $('.visa-card-active .dropdown-btn')[0].click();
   // Extract data attributes
    var minAge  = parseInt($(this).data('minimum-age'));   // e.g., 17
    var maxAge  = parseInt($(this).data('maximum-age'));   // e.g., 120
    var minAppt = parseInt($(this).data('minimum-appointment-days')) || 0;

 
    // Max DOB = Today - minAge years
    var maxDob = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());

    // Min DOB = Today - maxAge years
    var minDob = new Date(today.getFullYear() - maxAge, today.getMonth(), today.getDate());

    $("#dob").attr("min", formatDate(minDob));
    $("#dob").attr("max", formatDate(maxDob));

    // ADD PASSPORT EXPIRY CHECK = TODAY + 6 MONTHS

    var passportMin = new Date();
    passportMin.setMonth(passportMin.getMonth() + 6);

    $("#passportExpiry").attr("min", formatDate(passportMin));

    // ADD TRAVEL START DATE = TODAY + (MIN APPOINTMENT DAYS + 1) (Default 0 +1)

    var travelMin = new Date();
    travelMin.setDate(travelMin.getDate() + (minAppt + 1));

    $("#travelStartDate").attr("min", formatDate(travelMin));
    $("#travelEndDate").attr("min", formatDate(travelMin));
});

document.getElementById("terms-and-cond").addEventListener("click",()=>{
  document.querySelector('.term-and-cond').style.display="block"
}); 

$("#travelStartDate").on("change", function() {
    var selectedStart = new Date($(this).val());
    if (!isNaN(selectedStart.getTime())) {
        selectedStart.setDate(selectedStart.getDate() + 1); // must be greater
        $("#travelEndDate").attr("min", formatDate(selectedStart));
    }
});

function formatDate(d) {
    var month = (d.getMonth() + 1).toString().padStart(2, '0');
    var day   = d.getDate().toString().padStart(2, '0');
    return d.getFullYear() + "-" + month + "-" + day;
}

function calculateAgeFromDOB(dob) {
  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  // If birthday hasn't occurred yet this year, subtract 1
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}



//POPUP 
function showPopup(message, autoClose = false) {
  const popup = document.getElementById("customPopup");
  const messageBox = document.getElementById("popupMessage");

  messageBox.textContent = message;

  popup.classList.remove("hidden");
  popup.classList.add("show");

  // Close on button click
  document.getElementById("popupCloseBtn").onclick = () => {
    popup.classList.remove("show");
    setTimeout(() => popup.classList.add("hidden"), 250);
  };

  // Optional auto-close
  if (autoClose) {
    setTimeout(() => {
      popup.classList.remove("show");
      setTimeout(() => popup.classList.add("hidden"), 250);
    }, autoClose);
  }
}

